import { useCallback, useRef } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import type { WaypointCallbackArgs } from '#src/app/shared/components/layout/lazy';

import { usePromoteFormState } from '../../../../formContext';

type Data = {
	variant: string;
	display: boolean;
};

type Actions = {
	onPositionChange: ({ currentPosition }: WaypointCallbackArgs) => void;
};

export function useShareActions(): ModelHookResult<Data, Actions> {
	const {
		data: { promoteShareOnComboExperiment },
	} = usePsfPromoteOrSharePageData();
	const track = useTracking();
	const [{ moreWaysExpanded }] = usePromoteFormState();
	const { variation } = promoteShareOnComboExperiment;
	const trackedRef = useRef(false);

	const onPositionChange = useCallback(
		({ currentPosition }: WaypointCallbackArgs) => {
			if (trackedRef.current || currentPosition === 'below') return;
			trackedRef.current = true;
			void track('combo_psf_share_actions_view');
		},
		[track],
	);

	return {
		data: {
			variant: variation,
			display: !moreWaysExpanded,
		},
		actions: {
			onPositionChange,
		},
	};
}
